import React from 'react';
import { Gallery } from 'components/gallery/Gallery';
import { GalleryItem } from 'components/gallery/GalleryItem';

export const GallerySlice = ({ title, items, isSplitPage, isArticle }) => {
  return (
    <Gallery title={title} isSplitPage={isSplitPage} isArticle={isArticle}>
      {items?.map((item, index) => (
        <GalleryItem key={index} image={item.image} title={item.title} caption={item.description} />
      ))}
    </Gallery>
  );
};

export default GallerySlice;
